import { createContext, useReducer, useRef, useState, useEffect } from "react";
import styled from "@emotion/styled";

const AppButton = styled.button`
  color: ${"lightgray"};
  background: ${({ disabled }) =>
    disabled
      ? "linear-gradient(180deg, #666666, #999999)"
      : "linear-gradient(180deg, #100c08,rgb(4, 114, 46))"};
  ${({ disabled }) =>
    disabled
      ? `text-shadow:rgb(0, 0, 0) 5px 5px 10px; box-shadow:rgb(128, 128, 128) 5px 5px 10px;`
      : `text-shadow: #cccccc 5px 5px 10px; box-shadow: #cccccc 5px 5px 10px;`};
`;

const CancelButton = styled.button`
  color: "#000000";
  background: "#ffffff";
`;

const AppButtonRecordList = styled.button`
  width: 200px;
  color: ${"lightgray"};
  background: ${({ disabled }) =>
    disabled
      ? "linear-gradient(180deg, #666666, #999999)"
      : "linear-gradient(180deg, #100c08, #32e647)"};
  ${({ disabled }) =>
    disabled &&
    `text-shadow: #cccccc 5px 5px 10px; box-shadow: #cccccc 5px 5px 10px;`};
`;

const AppContext = createContext();

const variableCheck = (variableName, variableValue) => {
  if (typeof variableValue === "object") {
    // string output
    console.log(
      "■[variableCheck][%s] %s:%s",
      typeof variableValue,
      variableName,
      JSON.stringify(variableValue),
    );

    //table output
    console.table(variableValue);
  } else {
    console.log(
      "■[variableCheck][%s] %s:%s",
      typeof variableValue,
      variableName,
      variableValue,
    );
  }
};

export const AppContextProvider = ({ children }) => {
  // const [apiHost, setApiHost] = useState("http://127.0.0.1:8000/");
  const [apiHost, setApiHost] = useState("https://api2.wacha.biz/");

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [alertMessage, setAlertMessage] = useState("alert:-");

  return (
    <AppContext
      value={{
        AppButton,
        AppButtonRecordList,
        CancelButton,
        variableCheck,
        apiHost,
        alertMessage,
      }}
    >
      {children}
    </AppContext>
  );
};

export default AppContext;
